<template>
  <div class="loot__button">
    <div
      class="button button--corner button--animated gtm-button gtm-get-kit"
      @click="takeRewards()"
    >
      {{ $t("loot.take_all") }}
    </div>
  </div>
</template>
<script>
export default {
  name: "LootButtons",
  methods: {
    takeRewards() {
      this.$store.commit("shop", "removeOpenedItems");
      // this.$store.commit("shop/writeShopViewType", "list");
      this.$store.commit("global/writeCurScreen", "shop");
    },
  },
};
</script>
